<template>
	<div class="dlogD">
		<div class="dlogD_tit">编辑资料</div>
		<div class="dlogD_form">
			<div class="dlogD_form_item">
				<div class="dlogD_form_item_tit">昵称</div>
				<div class="dlogD_form_item_inp">
					<input v-model="nickname" type="" name="" id="" value="" />
				</div>
			</div>
			<div class="dlogD_form_item">
				<div class="dlogD_form_item_tit">自我介绍</div>
				<div class="dlogD_form_item_inp">
					<textarea v-model="introduce_myself" name="" rows="5" cols=""></textarea>
				</div>
			</div>
			<div class="dlogD_form_item">
				<div class="dlogD_form_item_tit">性别</div>
				<div class="dlogD_form_item_inp" style="display: inline-flex;align-items: center;">
					<template>
						<el-radio v-model="sex" label="1">男</el-radio>
						<el-radio v-model="sex" label="2">女</el-radio>
					</template>
				</div>
			</div>
		</div>
		<div class="dlogD_footer">
			<button @click="close">取消</button>
			<button @click="save_api">确认并提交</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				nickname: '',
				introduce_myself: '',
				sex: '1',
			}
		},
		created: function() {
			let _this = this;
			_this.nickname = JSON.parse(localStorage.getItem('ind_user')).nickname;
			_this.introduce_myself = JSON.parse(localStorage.getItem('ind_user')).introduce_myself;
			_this.sex = JSON.parse(localStorage.getItem('ind_user')).sex;
		},
		mounted: function() {

		},
		methods: {
			/**  * -----保存     * @version 1.0  * @author 您的大名 2019年12月3日  * */
			save_api() {
				let _this = this;
				let params = {
					nickname: _this.nickname,
					sex: _this.sex,
					introduce_myself: _this.introduce_myself
				};
				_this.postApi('/api/member/updateMemberInfo', params)
					.then((res) => {
						//console.log(res)
						if(res.status == '00') {
							_this.$message.success('保存成功');
							let uObj = JSON.parse(localStorage.getItem('ind_user'));
							uObj.nickname = _this.nickname;
							uObj.sex = _this.sex;
							uObj.introduce_myself = _this.introduce_myself;
							localStorage.setItem("ind_user",JSON.stringify(uObj));
							_this.close();
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/**  * -----关闭     * @version 1.0  * @author 您的大名 2019年12月3日  * */
			close() {
				let _this = this;
				Object.assign(this.$data, this.$options.data());
				_this.$emit('parentMethod', 'user_edit');
			},
		}
	}
</script>

<style scoped>

</style>